<template>
  <div>
    <h1 class="mdn-Heading mdn-Heading--sm">Orientações para criação de Menus</h1>

    <div class="pt-3 mdn-Text mdn-Text--body">
      <p class="mb-5">
        Olá, você está na orientação sobre a criação de Menus.
      </p>
      <p>
        Antes de criar um Menu é necessário ter uma rota criada. 
      </p>
      <p>  
        Após a criação da rota, é necessário a criação de um caminho (URL).
      </p>
      <p>  
        Todo Menu deve estar associado a um módulo, caso o módulo que deseje não esteja criado, será necessário cria-lo.
      </p>
      <p>  
        O permissionamento ao Menu é feito através dos Perfis, portanto é necessário que um perfil exista para utilizar o Menu.
      </p>
      <p>  
        Após a criação da rota, do caminho, do módulo e do perfil será possível criar um Menu, conforme listados abaixo:
      </p>
    </div>
    <div class="ms-5">
      <img src="@/assets/etapas-menu.png">
    </div>

    <div class="mdn-Row mdn-u-justifyContent-xs-end">
      <div class="mdn-Col-xs-2 mdn-u-padding--xs mdn-u-marginTop--xs ">
        <router-link to="/app/menus/principal" class="mdn-Button mdn-Button--primary mdn-Button--lg mdn-Button--block">
            <span>Voltar</span>
          </router-link>
      </div>
    </div>
  </div>
  
</template>

<script>
export default {
  name: "OrientacoesPage",
};
</script>
